// @flow
import { QUOTATION_FORM } from 'Client/cms/toolkit/constants';
import { ProductQuotationFormLine } from 'Components/lines/product-quotation-form-line/ProductQuotationFormLine';

import { productQuotationFormResolver } from './productQuotationForm.resolver';

export const productQuotationFormDescriptor = {
  name: QUOTATION_FORM,
  component: ProductQuotationFormLine,
  resolve: productQuotationFormResolver.resolve,
};
